import axios from "axios";
import { BASE_URL } from "../ultilitarios/system";

export function getAccounts(itemId: string) {
  return axios.get(`${BASE_URL}/pluggy/accounts/${itemId}`);
}
